export default __webpack_public_path__ + "50f7717a081e5b9e239077e8ca574b66.svg";